import * as THREE from 'three';

const OPAQUE_OPACITY = 1;
const TRANSLUCENT_OPACITY = 0.5;

export function toggleOpacity(objectGroup: THREE.Group): void {
  objectGroup.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return;

    const materials = Array.isArray(child.material)
      ? child.material
      : [child.material];

    materials.forEach((material) => {
      material.opacity =
        material.opacity === OPAQUE_OPACITY
          ? TRANSLUCENT_OPACITY
          : OPAQUE_OPACITY;
      material.transparent = material.opacity < OPAQUE_OPACITY;
      material.needsUpdate = true;
    });
  });
}
